<template>
  <div class="codemirror">
    <div ref="ace" class="ace-editor" :style="{ height: displayHeight }"></div>
  </div>
</template>

<script>
import ace from "ace-builds";
import "ace-builds/src-noconflict/snippets/javascript";
import "ace-builds/src-noconflict/snippets/html";
import "ace-builds/src-noconflict/snippets/css";
import "ace-builds/src-noconflict/snippets/scss";
import "ace-builds/src-noconflict/snippets/json";
import "ace-builds/src-noconflict/snippets/java";
import "ace-builds/src-noconflict/snippets/text";
import "ace-builds/src-noconflict/snippets/sql";
import "ace-builds/src-noconflict/snippets/sqlserver";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/mode-sqlserver";

export default {
  name: "SqlCodeEditor",
  props: {
    value: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "javascript"
    },
    userWorker: {
      // 是否开启语法检查，默认开启
      type: Boolean,
      default: true
    },
    displayHeight: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      aceEditor: null,
      themePath: "ace/theme/sqlserver", // 不导入 webpack-resolver，该模块路径会报错
      modePath: "ace/mode/sql", // 同上
      codeValue: ""
    };
  },

  mounted() {
    this.aceEditor = ace.edit(this.$refs.ace, {
      fontSize: 12, // 编辑器内字体大小
      theme: this.themePath, // 默认设置的主题
      mode: this.modePath, // 默认设置的语言模式
      tabSize: 2, // 制表符设置为2个空格大小
      readOnly: this.readonly,
      highlightActiveLine: true,
      value: this.codeValue
    });
    this.aceEditor.setOptions({
      enableBasicAutocompletion: true,
      enableSnippets: true, // 设置代码片段提示
      enableLiveAutocompletion: true // 设置自动提示
    });

    if (this.mode === "json") {
      this.setJsonMode();
    } else if (this.mode === "css") {
      this.setCssMode();
    }

    if (!this.userWorker) {
      this.aceEditor.getSession().setUseWorker(false);
    }

    // 编辑时同步数据
    this.aceEditor.getSession().on("change", (ev) => {
      // this.$emit('update:value', this.aceEditor.getValue())  // 触发更新事件, 实现.sync双向绑定！！
      this.$emit("input", this.aceEditor.getValue());
    });
  },

  methods: {
    setJsonMode() {
      this.aceEditor.getSession().setMode("ace/mode/json");
    },

    setCssMode() {
      this.aceEditor.getSession().setMode("ace/mode/css");
    },

    getEditorAnnotations() {
      return this.aceEditor.getSession().getAnnotations();
    },

    setValue(newValue) {
      this.aceEditor.getSession().setValue(newValue);
    }
  }
};
</script>

<style lang="less" scoped>
.codemirror {
  .ace-editor {
    min-height: 400px !important;
  }

  .ace-sqlserver .ace_print-margin {
    width: 0px;
  }

  .ace_editor,
  .ace_editor * {
    font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }
}
</style>
